module.exports = __webpack_public_path__ + "static/img/artist-acey@2x.47be259.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/artist/artist-acey@2x.png
// module id = gapm
// module chunks = 12